// 英文
export default {
  readMore: 'Read More',
  startForFree: 'Start for free',
  required: '{name} is required',
  tryForFree: 'Try For Free',
  CarouselTitle: 'empowers global enterprises, helping businesses achieve steady development.',
  publicConsultation: {
    title1: 'Cloudun ',
    title2: 'AI SaaS',
    title3: ' Consulting & Experience',
    item1: 'AI Ads',
    item2: 'EKYC',
    item3: 'Luna AI Robot',
    item4: 'Anti-Fraud Services',
    item5: 'Credit Scoring Services',
    productGroup: 'The product you would like to inquire about is:',
    submitTip: 'By submitting the form, you agree that Cloudun and its authorized partners may contact you through the contact information you provide, and that the data will only be used for communication with you.',
    form: {
      product: 'product',
      companyName: 'Company Name',
      contactPersonName: 'Contact Person Name',
      contactPersonPhone: 'Contact Person Phone Number',
      descriptionOfNeeds: 'Description of Needs'
    }
  },
  home: {
    title1: 'AI & AlGORITHMS',
    title2: 'Empowering Digital Finance With',
    EKYC: {
      title1: ' with Visual Anti-Fraud Capabilities',
      title2: 'EKYC Service',
      ProductTitle1: 'ID Document Recognition',
      ProductSubTitle1: 'Accurately recognizes hundreds of ID documents from 10+ major countries, ensuring fast, seamless, and efficient data capture.',
      ProductTitle2: 'Liveness Detection',
      ProductSubTitle2: 'Rapidly authenticates user to prevent various fraud.',
      ProductTitle3: 'Advanced Face Recognition',
      ProductSubTitle3: 'Leverages advanced facial recognition for in-database search and comparison, uncovering deeper user insights.',
      ProductTitle4: 'EKYC Fraud Detection',
      ProductSubTitle4: 'Precisely identifies dozens of ID and liveness fraud types, safeguarding your business from fraud risks.'
    },
    creditScore: {
      title1: 'Precise',
      title2: 'CREDIT SCORING MODEL',
      title3: 'Powered By Massive Big Data, Ensuring Stable Business Growth.',
      ProductTitle1: 'Blacklist',
      ProductSubTitle1: 'Extensive data coverage across 10+ leading digital finance hubs globally, effectively blocking high-risk users and rapidly improving business performance.',
      ProductTitle2: 'Pre-Audit',
      ProductSubTitle2: 'Quickly conducts initial user credit assessment based on three key verification factors, helping businesses save on unnecessary third-party costs in subsequent processes.',
      ProductTitle3: 'Comprehensive Audit',
      ProductSubTitle3: 'A multidimensional model built upon tens of thousands of feature points, effectively identifying risks and accurately calculating user credit.',
      ProductTitle4: 'Credit Limit Assessment',
      ProductSubTitle4: 'Scientifically assesses users\' effective credit limits, reducing risk while rapidly increasing average transaction values and improving business profitability.'
    },
    antiFraud: {
      title1: 'Continuously Evolving To Maintain Cutting-edge',
      title2: 'ANTI-FRAUD CAPABILITIES, ',
      title3: 'Staying One Step Ahead.',
      ProductTitle1: 'EKYC Fraud Detect',
      ProductTitle2: 'Device Anti-fraud',
      ProductTitle3: 'IP Anti-fraud',
      ProductTitle4: 'Card Anti-fraud',
      standardProduct: 'GPS Anti-fraud'
    },
    lunaAI: {
      title1: 'Luna AI Voice Robot,',
      title2: 'The Best Way to Reach Customers Efficiently',
      repaymentAITitle: 'Repayment Reminder AI Voice Robot',
      repaymentAIText: 'Leveraging Cloudun\'s  intelligent cloud contact center service and an AI robot with high-performance repayment strategy scripts based on deep learning, we provide a one-stop intelligent voice outreach solution to improve repayment rates.',
      customerServiceAITitle: 'Customer Service AI Voice Robot',
      customerServiceAIText: 'Tailor-made AI customer service system based on your enterprise knowledge base and business processes, opening a new era of 24/7 intelligent service for you.',
      marketingAITitle: 'Marketing AI Voice Robot',
      marketingAIText: 'AI marketing outbound agents empower enterprise customers to achieve full lifecycle value management and intelligent marketing throughout the customer journey.',
      multilingualAITitle: 'Multilingual AI Voice Robot',
      multilingualAIText: 'Instantly have your own localized, human-like voice outreach AI employee.',
      LLMVoiceTitle: 'LLM Voice Dialogue Expert',
      LLMVoiceText: 'Leverages LLM to accurately understand user intent and generate real-time voice interactions, creating a sophisticated communication channel for efficient user conversion.',
      intelligentContactTitle: 'Intelligent Contact Center Communication Platform',
      intelligentContactText: 'Feature-rich communication platform establishes a stable and reliable channel for you to reach users.'
    },
    overseasMarket: {
      title1: 'AI ADS SERVICE ',
      title2: 'Accelerate Your Overseas Marketing 10 Times Faster Production, 10 Times Higher Traffic',
      applicationMarketTitle: 'Intelligent App Store Optimization',
      applicationMarketText: 'Professional designers and operations team customize app store design for your app, from upload videos to graphic comment operations, taking over traffic and improving download conversion.',
      investmentFlowTitle: 'AIGC Advertising Contents for Overseas Market',
      investmentFlowText: 'Rapid AIGC content creation dramatically reduces costs and boosts overseas traffic.',
      majorTitle: 'Professional Overseas Advertising Services',
      majorText: 'Our expert team leverages global platforms to deliver massive user acquisition and ROI improvements.'
    },
    solution: {
      title: 'Partner with Us for Profitable Growth',
      item1Title: 'Online Loan End-to-End Solution',
      item1Text: 'From consultation, business model establishment, customized development and deployment, to operation guidance and operation analysis in the early stage of business, and finally to complete transfer of operation strategy and the code, to achieve comprehensive business solutions.',
      item2Title: 'Overseas Market User Acquisition Full-Link Solution',
      item2Text: 'From app store optimization to ad creative multimedia production, and finally to professional advertising team services for massive user acquisition.'
    },
    ISOAuthentication: {
      title: 'Global Certifications',
      item1: 'Cloudun AI has obtained ISO27001 international authoritative certification, possessing a risk management system covering the entire process of information security, demonstrating comprehensive capabilities from data protection to compliant operations. We guarantee the security of your privacy and trade secrets with globally leading standards, helping your business easily comply with stringent international regulations such as GDPR.',
      subTitle: 'Computer Software Copyright Registration Certificates',
      item2: 'Cloudun AI has obtained nearly 20 computer software copyright registration certificates, realizing independent intellectual property construction and protection covering core areas such as core risk control algorithms, big data computing, and CV view recognition. These technological achievements provide strong support for customers\' digital upgrades, ensuring the continuous, safe, and stable operation of business systems.',
      certificate2: 'Computer Software Copyright Registration Certificates'
    },
    businessMap: {
      title: 'The countries we serve'
    },
    startFor: {
      title: 'Experience Cloudun SaaS Platform',
      subTitle: 'Accelerate Your Business'
    }
  },
  EKYC: {
    slogan1: 'With Visual Anti-Fraud',
    slogan2: 'EKYC',
    subSlogan: 'Providing a seamless authentication experience for customers and reliable EKYC data for your business.',
    trialGuidance: 'Experience Seamless EKYC with Anti-Fraud Capabilities.',
    IDDetect: {
      title: 'ID Detect',
      introduction: 'Accurately recognizes over a hundred document types from 10+ major countries for fast, seamless, and efficient document entry.',
      introductionItem1: 'Mature client-side SDK solution for quick integration.',
      introductionItem2: 'Exceptional user experience for higher customer conversion rates.',
      introductionItem3: 'Supports all document types across various countries with a recognition rate of up to 99.9%.'
    },
    livenessDetect: {
      title: 'Liveness Detect',
      introduction: 'Quickly verifies whether a user is a real person, effectively preventing various fraud attacks.',
      introductionItem1Title: 'User-friendly',
      introductionItem1Text: 'Seamless user experience for smooth authentication.',
      introductionItem2Title: 'Quick Integration',
      introductionItem2Text: 'Complete, end-to-end authentication interface, zero front-end development required.',
      introductionItem3Title: 'Multi-Platform Support',
      introductionItem3Text: 'iOS SDK, Android SDK, web H5, comprehensively supporting your diverse products.'
    },
    faceDetect: {
      title: 'Ad. Face Detect',
      introduction: 'Advanced facial recognition and comparison capabilities for in-database searching to uncover more hidden user information.',
      introductionItem1Title: 'Face Comparison Capability',
      introductionItem1Text: 'Using facial recognition and comparison technology to match a user\'s selfie with their ID photo, confirming the applicant\'s identity.',
      introductionItem2Title: 'Face Search Capability',
      introductionItem2Text: 'Retrieves a user\'s historical in-database information (historical ID, application, repayment status).'
    },
    fraudDetect: {
      title: 'EKYC Fraud Detect',
      introduction: 'Accurately identifies over ten types of document fraud and over ten types of liveness fraud, protecting your business from fraud risks.',
      exampleItem1: 'Screen Face Replay Detection',
      exampleItem2: 'Face Smear Detection',
      exampleItem3: 'Exaggerated Facial Expression Detection',
      exampleItem4: 'AI Background Replacement Detection',
      exampleItem5: 'AIGC Face Detection',
      tip: 'The above are de-sensitized examples of fraud images.'
    },
    feature: {
      featureItem1Label: 'Number of Calls Processed',
      featureItem1Value: '200,000,000+',
      featureItem2Label: 'Number of Countries Covered',
      featureItem2Value: '8+',
      featureItem3Label: 'Number of Document Types Supported by OCR',
      featureItem3Value: '50+'
    }
  },
  creditScore: {
    slogan1: 'CLOUDUN CREDIT SCORE',
    slogan2: 'For Stable Business Growth',
    subSlogan: 'Leveraging massive datasets and multi-dimensional risk control models to accurately assess creditworthiness, helping businesses reduce risk while rapidly increasing per-transaction value and overall profitability.',
    trialGuidance: 'Improve performance using big data risk control models together with many advanced companies',
    blacklist: {
      title: 'Blacklist',
      introduction: 'Massive data foundation covering 10+ major digital finance countries, effectively blocking undesirable users and rapidly improving business performance.'
    },
    preAudit: {
      title: 'Pre-Audit',
      introduction: 'Quickly performs an initial credit assessment based on three key elements, helping businesses save on unnecessary third-party costs in later stages.'
    },
    audit: {
      title: 'Audit',
      introduction: 'Multi-dimensional model based on 20,000+ feature points, effectively identifying risks and accurately calculating user credit scores.'
    },
    amountLimit: {
      title: 'Amount limit',
      introduction: 'Scientifically calculates a user\'s effective credit limit, reducing risk while rapidly increasing per-transaction value and overall profitability.'
    },
    feature: {
      featureItem1Label: 'Countries Served',
      featureItem1Value: '8+',
      featureItem2Label: 'Projects Served',
      featureItem2Value: '100+',
      featureItem3Label: 'API Calls',
      featureItem3Value: '160 Million+',
      featureItem4Label: 'Loan Amount',
      featureItem4Value: '$5 Billion+',
      featureItem5Label: 'Model Iterations',
      featureItem5Value: '500+',
      featureItem6Label: 'Feature Count',
      featureItem6Value: '200,000+'
    }
  },
  antiFraud: {
    slogan1: 'AI ANTI-FRAUD',
    slogan2: 'Always One Step Ahead',
    subSlogan: 'Continuously evolving ANTI-FRAUD server, staying one step ahead.',
    trialGuidance: 'Integrate Cloudun Anti-Fraud to Protect Your Business Safe',
    functionIntroduction: 'With the proliferation of ever-evolving fraud tactics, we leverage big data technology to extract features from user-entered information and device data. This enables us to comprehensively identify fraudulent activities such as document forgery and coordinated "brushing" by fraud rings, safeguarding your business.',
    feature: {
      featureItem1Label: 'Call Volume',
      featureItem1Value: '10,000,000+',
      featureItem2Label: 'Fraudulent User Identification Rate',
      featureItem2Value: '95+%',
      featureItem3Label: 'Fraudulent Users Identified',
      featureItem3Value: '1,000,000+',
      featureItem4Label: 'Self-Developed Anti-Fraud Models Deployed',
      featureItem4Value: '20+'
    }
  },
  lunaAi: {
    slogan1: 'LUNA AI VOICE ROBOT',
    subSlogan: 'AI Voice Outbound Agent, the preferred method for efficiently reaching customers in the new era.',
    subTag1: 'Repayment Reminder AI Voice Robot',
    subTag2: 'Customer Service AI Voice Robot',
    subTag3: 'Marketing AI Voice Robot',
    trialGuidance: 'Discover the future of customer engagement',
    repaymentReminder: {
      title: 'Repayment Reminder AI Voice Outbound Robot',
      introduction: 'Relying on Cloudun\'s intelligent cloud contact center services, and an AI robot with deep learning high-performance repayment strategy scripts, we provide you with a one-stop intelligent voice outbound solution to improve repayment rates.',
      introductionItem1: 'Customize Exclusive AI Staff: Precisely set language style, voice tone, and communication tone.',
      introductionItem2: 'Adapt to various repayment reminder strategies, deeply matching reminder methods for different customer repayment stages.',
      introductionItem3: 'Develop comprehensive outbound strategies to effectively improve overall business repayment rates and enable intelligent repayment management.'
    },
    customerService: {
      title: 'Customer Service AI Voice Robot',
      introduction: 'Relying on your enterprise knowledge base and business processes, we tailor a unique AI customer service system for your enterprise, opening a new era of 24/7 online intelligent service.',
      introductionItem1Title: 'Round-the-Clock Service',
      introductionItem1Text: '24 hour continual service.',
      introductionItem2Title: 'Smart Learning and Adaptation',
      introductionItem2Text: 'Intelligent learning evolution.',
      introductionItem3Title: 'Personalized Service Experience',
      introductionItem3Text: 'Considerate service experience.'
    },
    marketing: {
      title: 'Marketing AI Voice Robot',
      introduction: 'Instantly have your own personalized, localized, human-like voice outbound dialogue AI staff.',
      introductionItem1: '1v1 Intelligent Voice Interaction: Accurately understand customer intent, precisely seize marketing opportunities, and drive customer conversion.',
      introductionItem2: 'Full Lifecycle Marketing Templates: Covering the entire chain of lead generation, follow-up, conversion, and repurchase with automated outbound intelligence and dialogue script library, reconstructing a new model for business growth.',
      introductionItem3: 'Learning Expert Dialogue Script Library: Supports uploading the enterprise\'s internal marketing expert knowledge base, quickly absorbing the essence of top dialogue scripts.'
    },
    multilingual: {
      title: 'Multilingual AI Voice Robot',
      introduction: 'Have your own personalized, highly human-like conversational AI agent, speaking your native language, in just one minute.',
      introductionItem1Title: 'Highly Human-Like Conversations',
      introductionItem1Text: 'Leveraging extensive language technology, including advanced features like intelligent interruption and tone continuation, our AI agents communicate more intelligently and closely resemble human interaction, optimizing the conversation experience. Rich voice tones enhance realism, fostering user connection and reducing hang-ups.',
      introductionItem2Title: 'Rapid Creation',
      introductionItem2Text: 'With a library of pre-built multilingual AI voice robot templates, you can go live instantly.'
    },
    largeModel: {
      title: 'Large Model Voice Dialogue Expert',
      introduction: 'Leveraging LLMs to rapidly learn high-quality conversational scripts and accurately identify user intent, build your business\'s advanced communication agent team, and efficiently convert users.',
      introductionItem1Title: 'Accurate User Intent Recognition',
      introductionItem1Text: 'Based on large language models, accurately identify user intent, providing strong support for customer behavior conversion and significantly improving business effectiveness.',
      introductionItem2Title: 'Intelligent Generation of Expert Dialogue Scripts',
      introductionItem2Text: 'Relying on advanced large language models, extracting the essence of massive high-quality scripts, in areas such as "repayment reminders," "intelligent customer service," and "marketing promotion," combined with personalized user information and intent expression, instantly generate targeted and professional communication scripts, comprehensively optimizing customer communication effectiveness.'
    },
    contactCenter: {
      title: 'Intelligent Contact Center Communication Platform',
      introduction: 'Resource-rich communication platform, establishing a stable and reliable service for you to reach users.',
      introductionItem1Title: 'Rich Resources',
      introductionItem1Text: 'Aggregates abundant high-quality overseas communication resources.',
      introductionItem2Title: 'Platform Stability',
      introductionItem2Text: 'Communication switching access platform with high reliability and stability.',
      introductionItem3Title: 'Time and Effort Saving',
      introductionItem3Text: 'Multi-country and multi-network resource integration, one-stop API access.'
    },
    feature: {
      featureItem1Title: 'Rapid Integration on the Same Day ',
      featureItem1: 'Ready-to-use Multilingual Voice Robots',
      featureItem2: 'Pre-built Intent Recognition and Dialogue Templates for Repayment Plans in Multiple Countries',
      featureItem3: 'Quick Completion of Customer Service Knowledge Base via Uploading Service Corpus',
      featureItem2Title: 'Increase User Reach Rate by Over',
      featureItem3Title: 'Increase Repayment Rate by Over'
    }
  },
  aiAds: {
    slogan1: 'AI ADS SERVICE',
    slogan2: 'Access To Massive Traffic',
    subSlogan: 'Accelerate Your Overseas Marketing with Our Expert Team: 10x Faster Deployment, 10x Higher Traffic',
    subTag1: 'Social Media Advertising',
    subTag2: 'Advertising Creative',
    subTag3: 'App Store Traffic',
    subTag4: 'Overseas Markets',
    trialGuidance: 'Get Massive Traffic Services Now',
    furnish: {
      title: 'Professional App Store Optimization',
      introduction: 'Professional designers and operators creates custom App Store designs for your app, handling everything from launch videos to image and comment management, increasing traffic and improving download conversions.',
      introductionItem1: 'App logo, App Store launch images, videos by UI Designer Design and AIGC Design',
      introductionItem2: 'Dedicated 1-on-1 service for your business growth'
    },
    material: {
      title: 'AIGC High-CTR Converting Video Ads',
      introduction: 'With powerful multimedia AIGC generation capabilities, you can quickly produce massive amounts of high-quality ad videos and image/text creatives. Significantly reduce advertising content production costs and usher in a new era of high-quality, high-volume overseas traffic acquisition.',
      introductionItem1: 'AIGC Original Digital Human Video Ads',
      introductionItem2: 'AIGC Digital Human Replaces Video Ads',
      introductionItem3: 'AIGC Original Image and Text Ads',
      introductionItem4: 'Multi-Language Support'
    },
    feature: {
      featureItem1Label: 'Supported Ad Creative Languages',
      featureItem1Value: '8 Countries',
      featureItem2Label: 'App Store Download Conversion Rate',
      featureItem2Value: '+50%',
      featureItem3Label: 'Advertising ROI Increased by',
      featureItem3Value: '30%'
    }
  },
  company: {
    title: 'Cloudun AI Empowers Global Financial Enterprises',
    submitTitle: 'Leveraging self-developed AI technology and FinTech, Cloudun empowers global financial enterprises to improve the efficiency of financial services, bringing better financial products and services to consumers.',
    companyHistory: {
      title: 'Cloudun Digital Finance Al Solution',
      item2018OneActive: 'Fintek ',
      item2018One: 'was founded, mainly engaged in loan SaaS developing.',
      item2019OneActive: 'Cloudun Cayman & Singapore',
      item2019One: ' was incorporated in May 2019.',
      item2019Two: 'The group started exploring fintech AI and technology services in ',
      item2019TwoActive: 'Indonesia.',
      item2020OneActive: 'Cloudun Indonesia',
      item2020One: 'was incorporated, started to provide EKYC\\Credit insights\\Digital lending consulting services in Indonesia.',
      item2021OneActive: 'Cloudun HK ',
      item2021One: 'was established, started business in Mexico, expanding product lines: AI Ads.',
      item2021Two: 'By the end of  2021, Cloudun provided services for 67 enterprise clients, with API call volume of over ',
      item2021TwoActive: '90 million times.',
      item2022OneActive: 'Cloudun Group ',
      item2022One: 'is continuously optimizing products in Mexico and Indonesian markets, constantly increasing enterprise clients, and maintaining sustainable business growth. In 2023, API calls have reached to 270 million times that year.',
      item2022Two: 'Completed Series A Funding.',
      item2024One: 'On the basis of maintaining stable growth in the existing market, Cloudun has explored horizontally into other regions such as the Philippines and vertically advance the development of intelligent operation systems such as AI chatbot.',
      item2024Two: 'By Dec 2024, Cloudun has provided services for 90+ enterprise clients with a financial transaction volume over US$5 billion dollars, connected nearly 50 million end users.',
      item2024Three: 'We partner with key players across the industrial chain, fostering collaboration and creating shared value.'
    }
  },
  solution: {
    slogan1: 'Partner With Us For Profitable Growth',
    subSlogan: 'From consultation, business model establishment, customized development and deployment, to operation guidance and operation analysis in the early stage of business, and finally to complete transfer of operation strategy and the code, to achieve comprehensive business solutions.',
    businessGrowth: {
      title: 'Business Growth and Profits',
      subTitle: 'Mature business experience, continuous service tracking, to ensure business objectives are achieved.'
    },
    consult: {
      title: 'Consult and Transfer',
      subTitle: 'Complete code delivery, commercial thinking, risk management strategy training and practical teaching, to ensure our clients have the ability to continue running the business.'
    },
    customization: {
      title: 'Customization and Deployment',
      subTitle1: 'Customization and DeploymentCustomer-oriented, customized exclusive solutions;',
      subTitle2: 'Strictly control the implementation process to maximize benefits.'
    }
  },
  el: {
    pleaseEnter: 'Please enter',
    submit: 'Submit'
  },
  publicNavigation: {
    navList: {
      item1: 'Home',
      item2: 'Products',
      item3: 'Solutions',
      item4: 'About Us'
    },
    menuList: {
      item1Title: 'EKYC',
      item1Subtitle: 'Providing a seamless authentication experience for customers and reliable EKYC data for your business.',
      item2Title: 'Cloudun credit score',
      item2Subtitle: 'Leveraging massive datasets and multi-dimensional risk control models to accurately assess creditworthiness, helping businesses reduce risk while rapidly increasing per-transaction value and overall profitability.',
      item3Title: 'AI Anti-Fraud',
      item3Subtitle: 'Continuously evolving ANTI-FRAUD server, staying one step ahead.',
      item4Title: 'Luna AI Voice Robot',
      item4Subtitle: 'AI Voice Outbound Agent, the preferred method for efficiently reaching customers in the new era.',
      item5Title: 'AI ADS SERVICE',
      item5Subtitle: 'Accelerate Your Overseas Marketing with Our Expert Team: 10x Faster Deployment, 10x Higher Traffic'
    }
  },
  publicFooter: {
    products: 'Products',
    product1: 'AI Ads',
    product2: 'EKYC',
    product3: 'Luna AI Robot',
    product4: 'Anti-Fraud Services',
    product5: 'Credit Scoring Services',
    solutions: 'Solutions',
    solutions1: 'Online Loan End-to-End Solution',
    solutions2: 'Overseas Market User Acquisition Full-Link Solution',
    company: 'Company',
    company1: 'About Us',
    contactUs: 'Contact Us',
    contactUs1: 'Phone',
    contactUs2: 'Email'
  }
}
